import { CfSpacers, Spacers } from "types/generic/types";

const CF_SPACERS_NONE = "none";

export const convertCfSpacersProps = (
  cfProp: CfSpacers | undefined | null,
): Spacers | undefined => {
  if (!cfProp) return undefined;
  return {
    marginBottom:
      cfProp.marginBottom && cfProp.marginBottom !== CF_SPACERS_NONE
        ? cfProp.marginBottom
        : undefined,
    marginTop:
      cfProp.marginTop && cfProp.marginTop !== CF_SPACERS_NONE
        ? cfProp.marginTop
        : undefined,
    paddingBottom:
      cfProp.paddingBottom && cfProp.paddingBottom !== CF_SPACERS_NONE
        ? cfProp.paddingBottom
        : undefined,
    paddingTop:
      cfProp.paddingTop && cfProp.paddingTop !== CF_SPACERS_NONE
        ? cfProp.paddingTop
        : undefined,
  };
};
